export default "__VITE_ASSET__CaY_iyUN__"